<script>
import axios from 'axios'

export default {
  name: 'TulipLiveness',
  data() {
    return {
      tulipLiveness: null,
      tulipLivenessLoader: false,
      tulipAgentLiveness: [],
      tulipAgentLivenessLoader: false,
      search: '',
      headerPageItems: [5, 10, 25, { text: 'All', value: -1 }],
      pagination: {
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headers: [
        { text: 'ID', value: 'hexID' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Type', value: 'type' },
        { text: 'Status', value: 'isAlive' }
      ]
    }
  },
  methods: {
    async getTulipStatus() {
      this.tulipLivenessLoader = true
      try {
        const response = await axios.get('/api/core/maintain/liveness/core')
        this.tulipLiveness = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.tulipLivenessLoader = false
      }
    },
    async getAgentStatus() {
      this.tulipAgentLivenessLoader = true
      try {
        const response = await axios.get('/api/core/maintain/liveness/agents')
        this.tulipAgentLiveness = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.tulipAgentLivenessLoader = false
      }
    }
  },
  mounted() {
    this.getTulipStatus()
    this.getAgentStatus()
  }
}
</script>

<template>
  <v-layout row wrap>
    <v-flex xs12 class="pb-2">
      <v-card
        style="border-radius: 10px"
        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
      >
        <v-card-title>
          <span class="body-1 beez-bold pl-3">Tulip Liveness</span>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              :loading="tulipLivenessLoader"
              flat
              icon
              @click="getTulipStatus()"
            >
              <v-icon>cached</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text v-if="tulipLiveness">
          <v-flex class="pt-3">
            <v-layout class="row wrap px-1">
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-label>
                  <span class="body-1 beez-bold">Workflow Engine </span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.workflowEngine ? 'green--text' : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-label>
                  <span class="body-1 beez-bold">Key Service</span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.keyserver ? 'green--text' : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-label>
                  <span class="body-1 beez-bold">Queue Service </span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.queueService ? 'green--text' : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-label>
                  <span class="body-1 beez-bold">Email Service </span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.emailService ? 'green--text' : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-4">
                <v-label>
                  <span class="body-1 beez-bold">DMS Service</span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.dmsservice ? 'green--text' : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-4">
                <v-label>
                  <span class="body-1 beez-bold">Key-Value store </span>
                  <br />
                  <br />
                  <v-icon
                    :class="
                      tulipLiveness.keyStoreService
                        ? 'green--text'
                        : 'red--text'
                    "
                    >favorite</v-icon
                  >
                </v-label>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card
            style="border-radius: 10px"
          >
            <v-card-title>
              <span class="body-1 beez-bold pl-3">Agent Liveness</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  @click="getAgentStatus()"
                  :loading="tulipAgentLivenessLoader"
                >
                  <v-icon>cached</v-icon>
                </v-btn>
                <span>Refresh</span>
              </v-tooltip>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :search="search"
                :headers="headers"
                :items="tulipAgentLiveness"
                :loading="tulipAgentLivenessLoader"
                :pagination.sync="pagination"
                :rows-per-page-items="headerPageItems"
                item-key="userHexId"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-left">{{ props.item.hexId }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.description }}</td>
                    <td class="text-xs-left">{{ props.item.type }}</td>
                    <td class="text-xs-left">
                      <v-icon
                        :class="
                          props.item.isAlive ? 'green--text' : 'red--text'
                        "
                        >favorite</v-icon
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped></style>
